export default __webpack_public_path__ + "static/media/power.90168caf.png";